<div class="custom-modal" style="margin: 20px">
  <div class="header">
    <h1 mat-dialog-title>Upload Arquivo</h1>
    <mat-icon mat-dialog-close="cancel">close</mat-icon>
  </div>
  <br /><br />
  <form class="d-flex flex-wrap form-items" [formGroup]="form">
    <mat-form-field class="min-width">
      <mat-label>Clientes:</mat-label>
      <mat-select formControlName="clienteSelecionado" (selectionChange)="selecionarCliente()">
        <!-- <mat-option value="">Todos</mat-option> -->
        <mat-option *ngFor="let d of listaClientes" [value]="d.clienteId">
          {{ d.nome }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="min-width">
      <mat-label>Operação:</mat-label>
      <mat-select formControlName="operacaoSelecionada">
        <!-- <mat-option value="">Todos</mat-option> -->
        <mat-option *ngFor="let o of listaOperacao" [value]="o.operacao">
          {{ o.operacao }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="width-full">
      <button type="button" mat-raised-button color="primary" (click)="fileInput.click()">
        Selecionar arquivo
      </button>
      <input hidden (change)="onFileChange($event)" #fileInput type="file" id="file" />
      {{ fileName }}
    </div>

    <div class="width-full" style="display: flex; justify-content: space-around; margin-top: 20px">
      <button type="button" mat-raised-button color="primary" [disabled]="file == null" (click)="UploadArquivoSalvar()">
        Salvar
      </button>
      <button type="button" mat-raised-button color="warn" (click)="dialogRef.close()">
        Fechar
      </button>
    </div>
  </form>
</div>
